import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type { Permission, PermissionsList, PermissionFormValues } from "../models/permission"
import { PermissionsListSchema, PermissionSchema } from "../models/permission"
import { permissionApi } from "../services/permissionApi"

const BASE_KEY = "admin-permissions"

export function usePermissionsList() {
  return useQuery<PermissionsList>({
    queryKey: [BASE_KEY],
    queryFn: () => permissionApi.getList() as Promise<PermissionsList>,
    staleTime: 1000 * 60 * 10,
  })
}

export function useCreatePermission() {
  const queryClient = useQueryClient()
  return useMutation<Permission, Error, PermissionFormValues>({
    mutationFn: (values) => permissionApi.create(values) as Promise<Permission>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useUpdatePermission() {
  const queryClient = useQueryClient()
  return useMutation<Permission, Error, { name: string; values: Partial<PermissionFormValues> }>({
    mutationFn: ({ name, values }) => permissionApi.update(name, values) as Promise<Permission>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useDeletePermission() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: (name) => permissionApi.delete(name) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}
